export default __webpack_public_path__ + "webflow.b7196b9b.png";